import api from '@/libs/axiosInstance';
import type { Pagination } from '@/types/pagination';
import type { BulkEmailBatchDetailItem, BulkEmailBatchSummary } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export interface SentBatchDetailsResponse {
  batch: BulkEmailBatchSummary & { body?: string };
  items: {
    meta: Pagination;
    data: BulkEmailBatchDetailItem[];
  };
}

const fetchSentBatchDetails = async (batchId: string): Promise<SentBatchDetailsResponse> => {
  const response = await api.get<{ data: SentBatchDetailsResponse }>(
    `/dashboard/messages/sent/${batchId}`
  );
  return response.data.data;
};

export const useSentBatchDetailsQuery = (batchId: string | null) => {
  return useQuery<SentBatchDetailsResponse, Error>({
    queryKey: ['sentBatchDetails', batchId],
    queryFn: () => fetchSentBatchDetails(batchId!),
    enabled: !!batchId,
    staleTime: 1000 * 60 * 5,
  });
};
